"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getPhoneMaskOptions", {
    enumerable: true,
    get: function() {
        return getPhoneMaskOptions;
    }
});
var _phone = require("@maskito/phone");
var _metadata = _interop_require_default(require("libphonenumber-js/min/metadata"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getPhoneMaskOptions = function(param) {
    var countryIsoCode = param.countryIsoCode, mask = param.mask;
    if (mask) return {
        mask: mask
    };
    var phoneOptions = (0, _phone.maskitoPhoneOptionsGenerator)({
        countryIsoCode: countryIsoCode,
        metadata: _metadata.default
    });
    return phoneOptions;
};
